import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { State } from 'src/app/store';
import { environmentSelector } from 'src/app/store/global/global.selectors';

@Injectable({
    providedIn: 'root',
})
export class StatusService {
    constructor(private http: HttpClient, private store: Store<State>) {}

    private configUrl = 'https://dev-api.bciti.info/health'; // URL to web api

    getStatus(): Observable<any> {
        return this.store.select(environmentSelector).pipe(
            switchMap((env) =>
                this.http
                    .get(
                        this.configUrl, // TODO: Replace with gateway endpoint
                        {
                            headers: new HttpHeaders({
                                'x-organisation': 'All',
                                'x-env': env.label.toLowerCase(),
                            }),
                        },
                    )
                    .pipe(
                        tap((_) => this.log('status Fetched')),
                        catchError(this.handleError<any>('getStatus', [])),
                    ),
            ),
        );
    }

    private log(message: string) {
        // this.messageService.add(`Configurations : ${message}`);
    }

    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }
}
